/* unplugin-vue-components disabled */import { render } from "./ai-editor.vue?vue&type=template&id=81bbcdc0&scoped=true"
import script from "./ai-editor.vue?vue&type=script&lang=js"
export * from "./ai-editor.vue?vue&type=script&lang=js"

import "./ai-editor.vue?vue&type=style&index=0&id=81bbcdc0&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81bbcdc0"],['__file',"src/components/ai-chat/ai-editor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "81bbcdc0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('81bbcdc0', __exports__)) {
    api.reload('81bbcdc0', __exports__)
  }
  
  module.hot.accept("./ai-editor.vue?vue&type=template&id=81bbcdc0&scoped=true", () => {
    api.rerender('81bbcdc0', render)
  })

}


export default __exports__